// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vv6R","type":"styles_type__3dBV3","choices":"styles_choices__14w6m"};